// Speil av functions/receipts/receiptWorkflowSnapshot.ts — hold dem like
// (src/services/receiptWorkflowSnapshot.test.js sammenligner dem).
//
// Arbeidsflyt-sporet (workflowSteps / workflowAuditTrail) lagres bare på bilagsraden,
// ikke også inne i receiptAnalysis. buildReceiptWorkflowContract regner det ut på nytt
// fra analysen, og bokføringshendelser legges senere til på raden. Den doble kopien
// utgjorde rundt 20 % av receiptInbox i produksjon (2026-09-30).
//
// Radens kopi vinner. Analysens brukes bare når raden mangler den, så ingen
// sporoppføring går tapt.

(function () {
  const RECEIPT_WORKFLOW_SNAPSHOT_FIELDS = ['workflowSteps', 'workflowAuditTrail'];

  const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

  const moveReceiptWorkflowSnapshotToEntry = (entry) => {
    if (!isPlainObject(entry) || !isPlainObject(entry.receiptAnalysis)) return entry;
    const analysis = entry.receiptAnalysis;
    if (!RECEIPT_WORKFLOW_SNAPSHOT_FIELDS.some((field) => field in analysis)) return entry;
    const next = { ...entry };
    const nextAnalysis = { ...analysis };
    RECEIPT_WORKFLOW_SNAPSHOT_FIELDS.forEach((field) => {
      if (!(field in analysis)) return;
      if (next[field] === undefined && analysis[field] !== undefined) next[field] = analysis[field];
      delete nextAnalysis[field];
    });
    next.receiptAnalysis = nextAnalysis;
    return next;
  };

  window.PlummeReceiptWorkflowSnapshot = { moveReceiptWorkflowSnapshotToEntry };
})();
